import {
  MockMap,
} from '@ama-sdk/core';
import {
  Journey,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createAcceptance,
  createJourney,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  MockAcceptance,
  MockJourneyElementCommon,
  RecursivePartial,
} from '@dapi/sdk/spec';
import {
  authorization,
  twoAdtJourneyTravelers,
} from '../../mock';
import {
  chargeableSeatsToPayForTwoPax,
  createSeatmapMockData,
  defaultCheckInBaggagePolicies,
  firstFreeSeatOnJourney,
  noItemToPayError,
  paymentRecords,
  roundTripBoardingPassWithSeats,
  roundTripBoardingPassWithSeats2,
  seatAvailabilityOverrides,
  secondCHSeatOnJourney,
  secondFreeSeatOnJourney,
} from '../../mock/data';

/**
 * OW 1Journey
 * 2ADT
 * Update Seats
 */

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: twoAdtJourneyTravelers
};

const journeys = [createJourney({
  template: journeyTemplate
})];
const {seatmap} = createSeatmapMockData(journeys, seatAvailabilityOverrides);

const checkedInJourneyElementFirstSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: firstFreeSeatOnJourney[0],
        checkInStatus: 'accepted',
        traveler: twoAdtJourneyTravelers[0],
        travelerId: twoAdtJourneyTravelers[0].id
      }
    })
  }
});

const checkedInJourneyElementSecondSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: secondFreeSeatOnJourney[0],
        checkInStatus: 'accepted',
        traveler: twoAdtJourneyTravelers[1],
        travelerId: twoAdtJourneyTravelers[1].id,
        id: twoAdtJourneyTravelers[1].id
      }
    }),
    id: twoAdtJourneyTravelers[1].id
  }
});

const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: [checkedInJourneyElementFirstSeat, checkedInJourneyElementSecondSeat],
    isAccepted: true
  }
});

export const ow1Journey2AdtUpdateSeat: MockMap = {
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],

  generateBoardingPasses: [
    createMockDataWithResponse(roundTripBoardingPassWithSeats, 201),
    createMockDataWithResponse(roundTripBoardingPassWithSeats, 201),
    createMockDataWithResponse(roundTripBoardingPassWithSeats2, 201),
    createMockDataWithResponse(roundTripBoardingPassWithSeats2, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(noItemToPayError)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstFreeSeatOnJourney[0], 201), createMockDataWithResponse({
      ...secondCHSeatOnJourney[0],
      journeyElementId: twoAdtJourneyTravelers[1].id
    }, 201)
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(acceptance, 201), createMockDataWithResponse(acceptance, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    }], 201)],
  retrieveJourney: [
    createMockData({
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  updateJourneySeats: [
    createMockData(firstFreeSeatOnJourney[0]), createMockData({
      ...secondCHSeatOnJourney[0],
      journeyElementId: twoAdtJourneyTravelers[1].id
    })
  ],
  updateJourneyElement: [
    createMockData(firstFreeSeatOnJourney[0]), createMockData({
      ...secondCHSeatOnJourney[0],
      journeyElementId: twoAdtJourneyTravelers[1].id
    })
  ]
};
